<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
      <!-- 中身だけがスクロールし、下の「閉じる」「登録」は常に見える（中身は Modal の既定の枠、ボタンは action の枠に置く） -->
      <div class="content-container-app">
          <div class="mx-12 mb-4">
            <div class="flex w-full mt-3 justify-around">
                <!-- 表示順 -->
              <div class="w-2/5">
                <div class="text-xs text-gray-600 font-bold">表示順 <span class="font-normal pl-1">（数値が小さいほど上にきます）</span></div>
                <NumericTextInput
                  name="sortNo"
                  v-model="user.sortNo"
                  class="border-gray text-center focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 rounded text-sm"
                />
              </div>

              <!-- 印鑑と、その右に名札用の顔写真（ユーザー指示） -->
              <div class="w-2/5 ml-2 flex items-start gap-8">
                <!-- 印鑑：画像の下に添付のボタン -->
                <div class="stamp-block">
                  <div class="text-xs text-gray-600 font-bold mb-1">印鑑</div>
                  <img ref="imageStamp" :src="user.stampUrl" id="imageStamp" loading="lazy" decoding="async" />
                  <div class="upload-button">
                    <PrimaryButton text="印鑑添付" @click="clickUploadStamp()" size="sm"/>
                    <input ref="inputStamp" type="file" accept="image/png" @change="changeStamp($event)" style="display:none" />
                  </div>
                </div>
                <!-- 顔写真：小さく見せるだけ。画像の下に「名札作成」（登録・差し替えと名札の出力はそのモーダルで）。編集のときだけ -->
                <div v-if="!isNew">
                  <div class="text-xs text-gray-600 font-bold mb-1">顔写真（名札用）</div>
                  <img v-if="user.photoUrl" :src="user.photoUrl" class="nameplate-photo" alt="" />
                  <div v-else class="nameplate-photo none">なし</div>
                  <div class="upload-button">
                    <PrimaryButton text="名札作成" size="sm" @click="openNameplate()" />
                  </div>
                </div>
              </div>
            </div>

            <div class="flex w-full mt-3 justify-around">
              <!-- 名前 -->
              <div class="w-2/5">
                <WmsTextInput
                  name="name"
                  caption="名前 （同じ名前は登録できません）"
                  v-model="user.userName"
                  :required="true"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded "
                />
              </div>

              <!-- かな -->
              <div class="w-2/5 ml-2">
                <WmsTextInput
                  name="kana"
                  caption="かな"
                  v-model="user.userKana"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>
            </div>

            <!-- 社員の名札：ローマ字・役職（ここでも「登録」で保存される）と顔写真（小さく表示。登録・差し替えと名札の出力は「名札作成」のモーダルで） -->
            <div class="flex w-full mt-3 justify-around">
              <div class="w-2/5">
                <WmsTextInput
                  name="userRomaji"
                  caption="ローマ字（名札用。例：Yamada Taro）"
                  v-model="user.userRomaji"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>
              <div class="w-2/5 ml-2">
                <WmsTextInput
                  name="userPost"
                  caption="役職（名札用。例：部長）"
                  v-model="user.userPost"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>
            </div>

            <div class="flex mt-3 justify-around">
              <!-- メアド -->
              <div class="w-2/5">
                <WmsTextInput
                  name="eMailAdress"
                  caption="メールアドレス（ログインID）"
                  v-model="user.eMailAdress"
                  :required="true"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>

              <!-- パス -->
              <div class="w-2/5 ml-2">
                <WmsTextInput
                  name="userPassword"
                  :caption="pasMsg"
                  v-model="user.userPassword"
                  :required="isNew"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>

            </div>

            <div class="flex mt-3 justify-around">
              <!-- メールのパス -->
              <div class="w-2/5">
                <WmsTextInput
                  name="mailPass"
                  caption="メールパスワード（見積書送付で使用します）"
                  v-model="user.mailPass"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>

              <!-- チャットワークアカウントID -->
              <div class="w-2/5 ml-2">
                <WmsTextInput
                  name="chatworkAccountId"
                  caption="チャットワークアカウントID"
                  v-model="user.chatworkAccountId"
                  class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                />
              </div>
            </div>

            <div class="flex mt-3 justify-around">
              <!-- グループ -->
              <div class="w-2/5">
                <div class="text-xs font-bold text-gray-700 mb-1">グループ</div>
                <select
                  class="border border-gray-300 rounded focus:ring-white text-sm w-full"
                  v-model="user.groupNum"
                  @change="getBossList(user.groupNum)"
                >
                  <option v-for="row in [1, 2, 3, 4, 5, 6, 7]" :key="'g'+row" class="" :value="row">
                    {{ row }}
                  </option>
                </select>
              </div>

              <!-- 上司 -->
              <div class="w-2/5 ml-2">
                <div class="text-xs font-bold text-gray-700 mb-1">上司</div>
                <select
                  class="border border-gray-300 rounded focus:ring-white text-sm w-full"
                  v-model="user.bossId"
                >
                  <option v-for="row in boss" :key="'b'+row.id" class="" :value="row.id">
                    {{ row.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="flex mt-3 justify-around">
              <!-- 給与奉行 社員番号 -->
              <div class="w-2/5">
                <div class="text-xs font-bold text-gray-700 mb-1">社員番号（給与奉行）</div>
                <input
                  type="number"
                  autocomplete="off"
                  placeholder="給与奉行にインポートする際に使う社員番号"
                  class="border border-gray-300 rounded leading-5 text-sm w-full"
                  v-model="user.userNum"
                  @wheel.prevent
                />
              </div>
              <div class="w-2/5 ml-2">
              </div>
            </div>

            <!-- タスク登録用メアド -->
            <div class="w-full mt-7">
              <div class="text-xs font-bold text-gray-700 mb-1">※{{ user.eMailAdress }} 以外に使用するメールアドレスがあれば入力してください。</div>
              <WmsTextInput
                name="eMailAdress"
                caption="タスク登録用メールアドレス"
                v-model="user.eMailAdressTask"
                class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
              />
            </div>

            <!-- 週休 -->
            <div class="mb-3 mt-10">
              <div class="text-xs mb-1 text-gray-700 font-bold">週休●日</div>
              <div class="flex">
                <PrimaryButton text="週休2日" size="sm" class="mx-2" :class="user.holidays==2?'bg-blue-700':'bg-gray-300'" @click="user.holidays=2"/>
                <PrimaryButton text="週休3日" size="sm" class="mx-2" :class="user.holidays==3?'bg-blue-700':'bg-gray-300'" @click="user.holidays=3"/>
              </div>
            </div>

            <!-- 休みが決まっている曜日 -->
            <div class="my-6">
              <div class="text-xs mb-1 text-gray-700 font-bold">休みが決まっている曜日（RLSの同行予定組みで使用します）</div>
              <div class="flex">
                <div v-for="w in weekList" :key="'week'+w.value" class="text-white font-bold text-sm">
                  <div class="mx-2 py-2 px-3 rounded cursor-pointer" :class="user.holidayWeeks.includes(w.value)?'bg-blue-700':'bg-gray-300'" @click="clickHolidayWeeks(w)">{{ w.text }}</div>
                </div>
              </div>
            </div>

            <!-- フルタイム時間 -->
            <div class="my-3">
              <div class="text-xs mb-1 text-gray-700 font-bold">基本勤務時間（環境整備の目標値に関係します）</div>
              <div class="flex">
                <PrimaryButton text="8時間" size="sm" class="mx-2" :class="user.fullTime==8?'bg-blue-700':'bg-gray-300'" @click="user.fullTime=8"/>
                <PrimaryButton text="時短" size="sm" class="mx-2" :class="user.fullTime!=8?'bg-blue-700':'bg-gray-300'" @click="user.fullTime=null"/>

                <input
                  v-if="user.fullTime!=8"
                  type="number"
                  class="border border-gray-300 rounded ml-3 p-1 text-center text-sm w-14"
                  :class="!user.fullTime||user.fullTime<1||user.fullTime>=8?'bg-red-100':''"
                  v-model="user.fullTime"
                />
                <span v-if="user.fullTime!=8" class="text-xs mt-auto ml-1">時間</span>

                <div v-if="!user.fullTime" class="text-red-700 text-xs font-bold self-center ml-2">※時短の基本勤務時間を入力してください。</div>
                <div v-else-if="user.fullTime<1" class="text-red-700 text-xs font-bold self-center ml-2">※勤務時間が短すぎます。</div>
              </div>
            </div>

            <!-- 権限 -->
            <div class="mt-10 text-sm text-gray-600 font-bold mb-1 flex">
              権限
              <div class="pl-5">
                <input
                  type="checkbox"
                  id="all"
                  class="h-4 w-4 border-gray-400 rounded cursor-pointer"
                  v-model="all"
                />
                <label for="all" class="pl-2 pr-5 py-5 cursor-pointer text-blue-800">全てにチェック</label>
              </div>
            </div>
            <div class="rounded border-gray px-5 py-4 flex flex-wrap bg-light-blue-50">
              <td v-for="a in auth" :key='a.item'>
                <div>
                  <input
                    type="checkbox"
                    :id="a.item"
                    class="h-4 w-4 my-2 border-gray-400 rounded cursor-pointer"
                    v-model="a.auth"
                  />
                  <label :for="a.item" class="pl-2 pr-5 py-1 cursor-pointer">{{ a.name }}</label>
                </div>
              </td>
            </div>

            <!-- 巡回員 -->
            <div class="mt-5 text-sm text-gray-600 font-bold mb-1">
              巡回員として登録
            </div>
            <div class="rounded border-gray px-5 py-4 bg-light-blue-50">
              <div v-for="a in patrolList" :key="'patrolList' + a.type">
                <div class="">
                  <input
                    type="checkbox"
                    :id="a.name"
                    class="h-4 w-4 my-2 border-gray-400 rounded cursor-pointer"
                    v-model="a.flag"
                  />
                  <label :for="a.name" class="pl-2 pr-5 py-1 cursor-pointer">{{ a.name }}</label>
                </div>

                <div v-if="a.type=='p1'" class="flex mt-1 mb-5 items-stretch">
                  <!-- 指導員講習受験番号 -->
                  <div class="">
                    <div class="text-xs font-bold text-blue-600 mb-1">指導員講習受験番号<span class="text-blue-700">（品質巡回員のみ適用）</span></div>
                    <input
                      text="number"
                      v-model="user.patrolId"
                      class="border py-2 px-3 border-blue-300 focus:ring-white rounded text-sm w-full"
                    />
                  </div>

                  <!-- エリア -->
                  <div class="ml-2">
                    <div class="text-xs font-bold text-blue-600 mb-1">巡回担当エリア<span class="text-blue-700">（品質巡回員のみ適用）</span></div>
                    <select
                      class="border border-blue-300 rounded focus:ring-white text-sm w-full"
                      v-model="user.area"
                    >
                      <option v-for="row in areaList" :key="'a'+row.id" class="" :value="row.name">
                        {{ row.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- その他 -->
            <div class="mt-5 text-sm text-gray-600 font-bold mb-1 flex">
              その他
              <div class="pl-5">
              </div>
            </div>
            <div class="rounded border-gray p-5 bg-light-blue-50">
              <table>
                <tbody>
                  <tr>
                    <td v-for="o in other" :key='o.item'>
                      <div>
                        <input
                          type="checkbox"
                          :id="o.item"
                          class="h-4 w-4 border-gray-400 rounded cursor-pointer green-check"
                          v-model="o.flag"
                        />
                        <label :for="o.item" class="pl-2 pr-5 py-5 cursor-pointer">{{ o.name }}</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="mt-5 text-sm text-gray-600 font-bold">部署<span class="text-red-700">（兼任部署設定欄は下にあります）</span></div>
            <div class="p-2 border border-gray-300 rounded mt-1 bg-light-blue-50">
              <PrimaryButton text="部署異動" size="normal" class="add-color mt-5" @click="addHistory()"/>
              <div v-for="(d, dIdx) in departmentHistory" :key='d.departmentId' class="mb-6">
                <div class="flex mt-3">
                  <!-- 部署 -->
                  <div class="text-xs text-gray-600 font-bold w-1/5">部署
                    <form class="border-gray rounded mt-1">
                      <select
                        name="departmentName"
                        v-model="departmentHistory[dIdx].departmentId"
                        @change="ChangeDepartment(dIdx)"
                        class="text-center focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block border-transparent w-full text-xs drop rounded"
                      >
                        <option
                          v-for="list in departmentList" :key="'l1' + list.departmentId"
                          :value="list.departmentId"
                          class="bg-white">
                          {{ list.name }}
                        </option>
                      </select>
                    </form>
                  </div>

                  <!-- 課 -->
                  <div class="text-xs text-gray-600 font-bold w-1/5 mx-1" v-tooltip="tip(d.departmentId, d.subList)">課・エリア
                    <form class="border-gray rounded mt-1">
                      <select
                        :disabled="!d.subList.length"
                        name="departmentSubName"
                        v-model="d.departmentSubId"
                        class="border-gray rounded text-center focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block border-transparent w-full text-xs drop"
                        :class="!d.subList.length?'cursor-not-allowed':''"
                      >
                        <option
                          v-for="list in d.subList" :key='list.id'
                          :value="list.id"
                          class="bg-white">
                          {{ list.name }}
                        </option>
                      </select>
                    </form>
                  </div>

                  <div class="text-xs text-gray-600 font-bold w-1/5">開始日<span v-if="d.departmentId && d.departmentId!=''" class="-top-0.5 ml-1 text-red-500"> * </span>
                    <WmsDateInput
                      name="startDay"
                      v-model="d.startDay"
                      @change="changeStartDay(d.startDay, dIdx)"
                    />
                  </div>
                  <div v-if="dIdx!=0" class="pt-6 mx-3">
                    ～
                  </div>
                  <div v-if="dIdx!=0" class="text-xs text-gray-600 font-bold w-1/5">終了日
                    <WmsTextInput
                      name="endDay"
                      v-model="d.endDay"
                      :disabled="true"
                    />
                  </div>

                  <TrashIcon v-if="dIdx==0" class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-6 h-6 mt-6 mx-3" @click="deleteHistory()"/>
                </div>
              </div>
            </div>

            <div class="mt-5 text-sm text-gray-600 font-bold flex">
              兼任部署

              <div @click="addDepartment2()" class="cursor-pointer ml-5">
                <PlusCircleIcon class="text-indigo-500 active:text-ingigo-600 w-6 h-6"/>
              </div>
            </div>
            <div class="p-2 border border-gray-300 rounded mt-1 bg-light-blue-50 flex flex-wrap gap-3">
              <div v-for="(d, i) in department2" :key="'d2' + d.departmentId" class="">
                <div class="flex">
                  <!-- 部署 -->
                  <div class="text-xs text-gray-600 font-bold w-44">
                    <div class="border-gray rounded mt-1">
                      <select
                        name="departmentName"
                        v-model="d.departmentId"
                        class="text-center focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 border-transparent w-full text-xs drop rounded"
                      >
                        <option
                          v-for="list in departmentList" :key="'l2'+list.departmentId"
                          :value="list.departmentId"
                          class="bg-white">
                          {{ list.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-6 h-6 self-center" @click="deleteDepartment2(i)"/>
                </div>
              </div>
            </div>

            <div class="mt-5 text-sm text-gray-600 font-bold flex">
              担当エリア（勤怠管理課・建物管理部のみ）

              <div @click="addArea()" class="cursor-pointer ml-5 ">
                <PlusCircleIcon class="text-indigo-500 active:text-ingigo-600 w-6 h-6"/>
              </div>
              <div @click="addTokyo23()" class="cursor-pointer ml-auto self-end border-b border-blue-700 text-blue-700">
                東京23区追加
              </div>
            </div>
            <div class="p-2 border border-gray-300 rounded mt-1 bg-light-blue-50 flex flex-wrap gap-3">
              <div v-for="(a, i) in user.areas" :key="'a' + i" class="">
                <div class="flex">
                  <WmsTextInput
                    :name="'area'+i"
                    v-model="user.areas[i]"
                    class="focus:bg-yellow-100 focus:ring-indigo-500 focus:border-indigo-500 block rounded"
                  />
                  <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-6 h-6 self-center" @click="deleteArea(i)"/>
                </div>
              </div>
            </div>

            <div class="mt-5 text-xs text-gray-700 font-bold">退職</div>
            <div class="p-2 border border-gray-300 rounded mt-1 bg-yellow-50 flex justify-between items-end">
              <div class="w-full mr-3">
                <div class="text-xs font-bold text-red-700 mb-1 flex items-center">
                  <Icon
                    iconName="Exclamation"
                    class="text-yellow-600"
                  />
                  【注意】最終勤務日が過ぎると自動でユーザーが削除されます
                  <Icon
                    iconName="Exclamation"
                    class="text-yellow-600"
                  />
                </div>
                <div class="text-xs font-bold text-gray-700 mb-1.5">最終勤務日（有給に入る前の実質の就労最終日）</div>
                <WmsDateInput
                  name="workEndDate"
                  v-model="user.workEndDate"
                />
              </div>
              <div class="w-full ml-3">
                <div class="text-xs font-bold text-gray-700 mb-1.5">退職日</div>
                <WmsDateInput
                  name="resignationDate"
                  v-model="user.resignationDate"
                />
              </div>
            </div>
          </div>

      </div>

      <template #action>
        <div class="content-container-app btn-bar">
          <div class="mx-1 mb-1 flex">
            <SecondaryButton text="閉じる" size="normal w-full mr-5" @click="closed()"/>
            <PrimaryButton text="登録" size="normal w-full ml-5" @click="register()"/>
          </div>
        </div>
      </template>
    </Modal>

    <!-- 社員の名札（このユーザーで開く。保存した役職・ローマ字・写真はこの画面にも反映する） -->
    <EmployeeNameplateModal
      v-model="nameplateShow"
      :open="nameplateOpen"
      :userId="user.id"
      @saved="onNameplateSaved"
    />
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import Icon from '@components/Icon.vue'
import { TrashIcon, PlusCircleIcon  } from '@vue-hero-icons/solid'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import NumericTextInput from '@components/NumericTextInput.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import EmployeeNameplateModal from './EmployeeNameplateModal.vue'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import { WEEK_NUM, TOKYO_23 } from '@libs/constants'
import * as logManager from '@managers/logManager'
import { PIGEON_CONFIG } from '@/config'

const USERROW = {
  id: null,
  sortNo: null,
  userName: '',
  userKana: '',
  eMailAdress: '',
  eMailAdressTask: '',
  userPassword: '',
  mailPass: '',
  chatworkAccountId: '',
  stampUrl: 'stamps/none.png',
  stampImage: null,
  holidays: 2,
  fullTime: 8,
  groupNum: null,
  boss: null,
  patrolId: null,
  area: null,
  holidayWeeks: [0],
  areas: [''],
  // 社員の名札（ローマ字・役職は「登録」で保存。写真は名札のモーダルで登録し、ここは小さく見せるだけ）
  userRomaji: '',
  userPost: '',
  hasNameplatePhoto: false,
  photoUrl: ''
}

const DEPHIS = {
  id: null,
  userId: null,
  departmentId: '',
  departmentSubId: null,
  subList: [],
  startDay: utils.getToday(),
  endDay: '',
  main: true
}

const DEP2 = {
  departmentId: null,
  main: false
}

export default {
  components: {
    Modal,
    Icon,
    TrashIcon,
    PlusCircleIcon,
    PrimaryButton,
    SecondaryButton,
    WmsTextInput,
    NumericTextInput,
    WmsDateInput,
    EmployeeNameplateModal
  },

  props: {
    target: {
      type: Object
    },
    open: {
      type: Number,
      default: null
    },
    // 品管担当エリア
    areaList: {
      type: Array
    },
    // 上司リスト
    bossList: {
      type: Array
    },
    // 既存のユーザーリスト
    userList: {
      type: Array
    },
    // 部署リスト
    departmentList: {
      type: Array
    },
    // 課リスト
    allDepartmentSubList: {
      type: Array
    }
  },

  data() {
    return {
      // ユーザーデータ
      user: utils.clone(USERROW),
      // 権限
      auth: [
        {item:'adminAuth', auth:false, name: '管理者'},
        {item:'userAuth', auth:false, name: 'ユーザー管理'},
        {item:'estimateApproveAuth', auth:false, name: '見積承認'},
        {item:'mainAuth', auth:false, name: 'メインタスク登録'},
        {item:'subAuth', auth:false, name: 'サブタスク登録'},
        {item:'estimateAuth', auth:false, name: '見積り登録'},
        {item:'patrolAuth', auth:false, name: '品質巡回'},
        {item:'roundCleanAuth', auth:false, name: '巡回清掃'},
        {item:'fixedCleanAuth', auth:false, name: '定期清掃'},
        {item:'facilityPatrolAuth', auth:false, name: '設備点検'},
        {item:'photoReportAuth', auth:false, name: '写真報告'},
        {item:'regularStaffAuth', auth:false, name: '社員面接'},
        {item:'evaluationAuth', auth:false, name: '評価シート'},
        {item:'bonusAuth', auth:false, name: '賞与設定'},
        {item:'contractAuth', auth:false, name: '契約情報'},
        {item:'rlsAuth', auth:false, name: 'RLS'},
        // クオリティレポートのメニュー（物件設定・予定・結果）を見られるか。全員 OFF から配る
        {item:'qualityReportAuth', auth:false, name: 'クオリティレポート'},
        // AKBS関連メニュー（申請一覧・登録済み一覧・出力・賃金）を見られるか。全員 OFF から配る
        {item:'akbsMenuAuth', auth:false, name: 'AKBS関連メニュー'},
        // 列は akbs_auth のまま。画面の呼び方は「雇用指示権限」（ユーザー決定 2026-10-09）
        {item:'akbsAuth', auth:false, name: '雇用指示の承認'},
        {item:'contractDetailAuth', auth:false, name: '契約詳細の承認'},
      ],
      // 巡回員として登録
      patrolList: [
        {type: 'p1', flag: false, name: '品質巡回員に登録 （品質巡回権限がある場合に有効）'},
        {type: 'p2', flag: false, name: '巡回清掃員に登録 （巡回清掃権限がある場合に有効）'},
        {type: 'p3', flag: false, name: '定期清掃員に登録 （定期清掃権限がある場合に有効）'},
        {type: 'p4', flag: false, name: '設備点検員に登録 （設備点検権限がある場合に有効）'},
        // 予定・結果の担当者の候補になる（受講番号・エリアは無し）
        {type: 'p5', flag: false, name: 'クオリティレポート作業員に登録 （クオリティレポート権限がある場合に有効）'},
      ],
      // その他
      other: [
        {item:'transmission', flag:false, name: 'デンタツ'},
        {item:'boss', flag:false, name: '上司'},
        {item:'partTimer', flag:false, name: 'パート'},
      ],
      // 所属部署履歴
      departmentHistory: [utils.clone(DEPHIS)],
      // 兼任部署
      department2: [utils.clone(DEP2)],
      // 新規作成
      isNew: false,
      // 全ての権限にチェックする
      all: false,
      // 曜日リスト
      weekList: WEEK_NUM,
      // 元データ
      origin: {},
      // 上司リスト
      boss: [],
      // 社員の名札のモーダル
      nameplateShow: false,
      nameplateOpen: 0
    }
  },

  computed: {
    /**
     * パスワードのcaption
     */
    pasMsg() {
      let result = 'ログインパスワード'
      if (!this.isNew) {
        result = 'ログインパスワード（変更したい時のみ記入してください）'
      }
      return result
    }
  },

  watch: {
    open() {
      this.getTarget()
    },

    /**
     * 権限全てにチェック
     */
    all() {
      if (this.all) {
        this.auth.forEach(a => {
          a.auth = true
        })
      }
    },

    /**
     * ログインユーザーＩＤ
     */
    loginUserId() {
      return this.$store.getters.user.id
    }
  },

  methods: {
    /**
     * 表示するデータ取得
     */
    async getTarget() {
      // 編集の場合
      if (this.target && Object.keys(this.target).length) {
        this.user = {
          id: this.target.id,
          sortNo: this.target.sortNo,
          userName: this.target.userName,
          userKana: this.target.userKana,
          eMailAdress: this.target.eMailAdress,
          eMailAdressTask: this.target.eMailAdressTask,
          userPassword: '',
          mailPass: this.target.mailPass? '●●●●': '',
          chatworkAccountId: this.target.chatworkAccountId,
          updateUserId: this.$store.getters.user.id,
          stampUrl: 'stamps/none.png',
          holidays: this.target.holidays,
          fullTime: this.target.fullTime,
          groupNum: this.target.groupNum,
          bossId: this.target.bossId,
          holidayWeeks: this.target.holidayWeeks || [],
          userNum: this.target.userNum,
          workEndDate: this.target.workEndDate,
          resignationDate: this.target.resignationDate,
          areas: this.target.areas,
          userRomaji: this.target.userRomaji || '',
          userPost: this.target.userPost || '',
          hasNameplatePhoto: !!this.target.hasNameplatePhoto,
          photoUrl: ''
        }

        if (!this.user.areas || !this.user.areas.length) {
          this.addArea()
        }

        this.loadNameplatePhoto()

        if (this.target.dualDepartmentId && this.target.dualDepartmentId.length) {
          this.department2 = this.target.dualDepartmentId.map((d) => {
            return { departmentId: d, main: false }
          })
        }

        this.getBossList(this.target.groupNum)

        this.origin = utils.clone(this.target)

        this.setImage(this.user,  'stamps/' + this.target.id + '.png')

        // 権限
        for (let authIdx = 0; authIdx < this.auth.length; authIdx++) {
          const a = this.auth[authIdx]
          a.auth = this.target[a.item]
        }
        // その他
        for (let otherIdx = 0; otherIdx < this.other.length; otherIdx++) {
          const o = this.other[otherIdx]
          o.flag = this.target[o.item]
        }
        // 所属部署履歴、巡回情報
        let history = await backend.searchData('userDepartment/getByUser', {id: this.target.id})
        if (history.data.data && history.data.data.length) {
          this.departmentHistory = history.data.data

          // 課リスト
          for (let i = 0; i < this.departmentHistory.length; i++) {
            const h = this.departmentHistory[i];
            h.endDay = utils.getDate(h.endDay)

            if (h.departmentId) {
              h.subList = this.allDepartmentSubList.filter((ads) => {
                return ads.departmentId == h.departmentId
              })
            }
          }
        }
        // 巡回員情報
        if (history.data.patrol) {
          for (let i = 0; i < history.data.patrol.length; i++) {
            const p = history.data.patrol[i]
            if (p.patrolId) {
              this.user.patrolId = p.patrolId
            }
            if (p.area) {
              this.user.area = p.area
            }
            for (let j = 0; j < this.patrolList.length; j++) {
              const tar = this.patrolList[j]
              if (p[tar.type]) {
                tar.flag = true
              }
            }
          }
        }
      } else {
        this.isNew = true
      }
    },

    async setImage(user, url) {
      var img = new Image();
      img.onload = function()  {
        /* 読み込み成功時の処理 */
        user.stampUrl = url
      }
      img.src = url;
    },

    /**
     * 部署選択イベント
     */
    ChangeDepartment(i) {
      // 課リスト変更
      this.departmentHistory[i].subList = this.allDepartmentSubList.filter((ads) => {
        return ads.departmentId == this.departmentHistory[i].departmentId
      })

      if (this.departmentHistory[i].subList && this.departmentHistory[i].subList.length == 1) {
        this.departmentHistory[i].departmentSubId = this.departmentHistory[i].subList[0].id
        this.departmentHistory[i].subName = this.departmentHistory[i].subList[0].name
      } else {
        this.departmentHistory[i].departmentSubId = null
        this.departmentHistory[i].subName = ''
      }
    },

    /**
     * アップロードボタン クリックイベント
     */
    async clickUploadStamp() {
      this.$refs.inputStamp.click()
    },

    /**
     * 部署異動ボタン（追加）
     */
    async addHistory() {
      let h = utils.clone(DEPHIS)

      if (this.departmentHistory.length > 0 && this.departmentHistory[0].departmentId && this.departmentHistory[0].departmentId != '') {
        if (this.departmentHistory[0].startDay && this.departmentHistory[0].startDay != '') {
          this.departmentHistory.splice(0, 0, h)
        } else {
          await dialogs.showErrorDialog('以前の部署確認', '1行目の開始日がありません。')
          return
        }
      } else {
        await dialogs.showErrorDialog('以前の部署確認', '1行目の部署がありません。')
        return
      }
      if (this.departmentHistory[1]) {
        this.departmentHistory[1].endDay = utils.addDays(this.departmentHistory[0].startDay, -1)
      }
    },

    /**
     * 兼任部署
     */
    addDepartment2() {
      this.department2.push(utils.clone(DEP2))
    },

    /**
     * 担当エリア追加
     */
    addArea() {
      if (!this.user.areas) {
        this.user.areas = []
      }
      this.user.areas.push('')
    },

    /**
     * 東京23区を追加
     */
    addTokyo23() {
      for (let i = 0; i < TOKYO_23.length; i++) {
        const row = TOKYO_23[i]
        const text = '東京都' + row
        if (!this.user.areas.includes(text)) {
          this.user.areas.push(text)
        }
      }
    },

    /**
     * 部署削除イベント
     */
    deleteHistory() {
      this.departmentHistory.splice(0, 1)
      if (!this.departmentHistory.length) {
        this.departmentHistory = [utils.clone(DEPHIS)]
      }
    },

    /**
     * 兼任部署削除イベント
     */
    deleteDepartment2(i) {
      this.department2.splice(i, 1)
      if (!this.department2 || !this.department2.length) {
        this.addDepartment2()
      }
    },

    /**
     * エリア削除
     * @param i 
     */
    deleteArea(i) {
      this.user.areas.splice(i, 1)
      if (!this.user.areas.length) {
        this.addArea()
      }
    },

    /**
     * 上司リスト取得
     * @param groupNum グループ番号
     */
    getBossList(groupNum) {
      this.boss = utils.clone(this.bossList)
      if (groupNum) {
        this.boss = this.bossList.filter((b) => {
          return !b.groupNum || Number(groupNum) < Number(b.groupNum)
        })
      }
    },

    /**
     * 印鑑 changeイベント
     */
    async changeStamp (event) {
      // 選択されたファイルの取得
      const reader = new FileReader()
        const f = event.target.files[0]
        if (!f) return
        reader.readAsDataURL(f)
        // 変換
        new Promise(() => {
          reader.onload = () => {
            const img = new Image();
            img.src = reader.result;

            img.onload = () => {
              // 新しいキャンバスを作成
              const canvas = document.createElement('canvas')
              // キャンバスに描画するためのコンテキストを取得
              const ctx = canvas.getContext('2d')
              // 画像をキャンバスに描画せずに直接リサイズ
              ctx.drawImage(img, 0, 0)
              // キャンバスの画像を再度DataURLに変換して圧縮率を下げる
              const compressedDataUrl = canvas.toDataURL('image/png', 1.0) // 圧縮率を設定

              this.user.stampImage = img.src
              this.user.stampUrl = img.src
              this.$refs.imageStamp.src = compressedDataUrl
            }
          }
        })
    },

    /**
     * 名札用の顔写真を小さく出すために取る（無ければ「なし」）
     * API: user/nameplatePhoto
     */
    async loadNameplatePhoto() {
      this.user.photoUrl = ''
      if (!this.user.id || !this.user.hasNameplatePhoto) {
        return
      }
      try {
        const res = await backend.getBlob('user/nameplatePhoto', { id: this.user.id })
        this.user.photoUrl = (window.URL || window.webkitURL).createObjectURL(new Blob([res.data], { type: 'image/jpeg' }))
      } catch (e) {
        console.log(e)
      }
    },

    /**
     * 社員の名札のモーダルを開く（このユーザーで）
     */
    openNameplate() {
      this.nameplateOpen++
      this.nameplateShow = true
    },

    /**
     * 名札のモーダルで保存したら、この画面の役職・ローマ字・写真もそろえる
     * @param saved 名札のモーダルのユーザー（userPost・userRomaji・hasPhoto）
     */
    onNameplateSaved(saved) {
      if (!saved) {
        return
      }
      this.user.userRomaji = saved.userRomaji || ''
      this.user.userPost = saved.userPost || ''
      this.user.hasNameplatePhoto = !!saved.hasPhoto
      this.loadNameplatePhoto()
    },

    /**
     * 初期化
     */
    closed() {
      // ユーザーデータ
      this.user = utils.clone(USERROW)
      // 権限
      this.auth.forEach((a) => a.auth = false)
      // 巡回員
      this.patrolList.forEach((a) => a.flag = false)
      // その他
      this.other.forEach((a) => a.flag = false)
      // 所属部署履歴
      this.departmentHistory = [utils.clone(DEPHIS)]
      // 兼任部署
      this.department2 = [utils.clone(DEP2)]
      // 新規作成
      this.isNew = false
      // 権限全てチェック
      this.all = false
      // 元データ
      this.origin = {}

      this.$emit('modalClose')
    },

    /**
     * 登録処理
     */
    async register() {
      // 名前チェック
      if (!this.user.userName) {
        await this.errRequired('名前')
        return
      } else {
        const tarName = utils.deleteSpace(utils.deleteKana(this.user.userName))
        this.user.deleteKana = utils.deleteKana(this.user.userName)
        for (let i = 0; i < this.userList.length; i++) {
          const u = this.userList[i]
          const name = utils.deleteSpace(utils.deleteKana(u.userName))
          if ((u.id && u.id != this.user.id && name == tarName) || (!u.id && name == tarName)) {
            await dialogs.showErrorDialog('同姓同名がいるため登録不可', `ユーザーIDが${u.id}の${name}さんと同姓同名です。\r\n外部データをインポートした際に紐づいてしまうため、同姓同名はご遠慮ください。`)
            return
          }
        }
      }

      // メアドチェック
      if (!this.user.eMailAdress || this.user.eMailAdress == '') {
        await this.errRequired('メールアドレス')
        return
      } else {
        const dupli = await backend.searchData('user/dupliMail', {mail: this.user.eMailAdress, id: this.user.id})
        if (dupli.data.data) {
          // console.log(dupli.data.data)
          await dialogs.showErrorDialog('メールアドレス重複', 'メールアドレスが過去に使用していたものも含め、重複しています。\r\n1度でも登録したメールアドレスは再度使用できません。\r\nメールアドレスを変更してください。\r\n（同じメールアドレスを使用していた人：' + dupli.data.data.userName + 'さん）')
          return
        }
      }

      // パスチェック
      if (this.isNew) {
        if (!this.user.userPassword || this.user.userPassword == '') {
          await this.errRequired('パスワード')
          return
        }
      }

      // 上司の名前取得
      this.setBoss()

      // 時短
      if (!this.user.fullTime) {
        await this.errRequired('基本勤務時間')
        return
      }
      if (Number(this.user.fullTime) < 1) {
        await dialogs.showErrorDialog('基本勤務時間', '基本勤務時間が短すぎます。')
        return
      }

      // デンタツ確認
      for (let oi = 0; oi < this.other.length; oi++) {
        const o = this.other[oi];
        if (o.item == 'transmission' && o.flag) {
          if (!this.departmentHistory[0].departmentId || this.departmentHistory[0].departmentId == '') {
            await dialogs.showErrorDialog('部署を選択してください。', '「デンタツ」にチェックがついています。\r\n部署を選択してください。')
            return
          }
          let tr = this.$store.getters.transDepartmentList
          let isTrans = false
          for (let tri = 0; tri < tr.length; tri++) {
            if (tr[tri].transDepartment == this.departmentHistory[0].departmentId) {
              isTrans = true
              break
            }
          }
          if (!isTrans) {
            await dialogs.showInfoDialog('デンタツ部署未設定', '選択した部署に紐づく「デンタツ」部署がまだ作られていません。\r\n「部署設定」画面で「デンタツ」部署を作成してください。')
          }
        }
      }

      // 部署チェック
      if (!this.departmentHistory.length || !this.departmentHistory[0].departmentId || this.departmentHistory[0].departmentId == undefined || this.departmentHistory[0].departmentId == '') {
        const dialogResult = await dialogs.showWarningConfirmDialog('部署', '部署が選択されていませんが、よろしいですか？')
        if (dialogResult != 'YES') {
          return
        }
      } else if (this.departmentHistory && this.departmentHistory[0] && this.departmentHistory[0].departmentId == 'd1444' && !this.user.mailPass) {
        const mpass = await dialogs.showWarningConfirmDialog('メールパスワードは未入力でよろしいですか？', '受託営業部ですが、見積書送付元アドレスに使用する「メールパスワード」が未入力です。')
        if (mpass != 'YES') {
          return
        }
      }

      // 休みが決まっている曜日チェック
      if (this.user.holidayWeeks && this.user.holidayWeeks.length) {
        const len = this.user.holidayWeeks.length
        if (this.user.holidays < len) {
          await dialogs.showErrorDialog('休みが決まっている曜日の数が多いです', `週休${this.user.holidays}日ですが、休みが決まっている曜日を${len}つ選択しています。`)
          return
        }
      }

      // 開始日チェック
      for (let i = 0; i < this.departmentHistory.length; i++) {
        const d = this.departmentHistory[i];
        if (d.departmentId != '' && (!d.startDay || d.startDay == '')) {
          await this.errRequired('部署の開始日')
          return
        }
      }

      // 退職チェック
      if (this.user.workEndDate) {
        if (this.user.resignationDate && this.user.resignationDate < this.user.workEndDate) {
          await dialogs.showErrorDialog('最終勤務日と退職日が不正', '最終勤務日の方が退職日よりも後になっています。')
          return
        }
        if (!this.user.resignationDate) {
          await dialogs.showErrorDialog('退職日を入力してください', '最終勤務日は入っていますが退職日はありません。')
          return
        }
      }

      if (this.user.workEndDate) {
        const log = await dialogs.showWarningConfirmDialog('最終勤務日に間違いはないですか？', '最終勤務日を過ぎると自動でユーザー削除されます。最終勤務日に間違いはないですか？')
        if (log != 'YES') {
          return
        }
      }

      // 権限ID
      let authId = null
      // その他ID
      let otherId = null

      // 更新の場合
      if (!this.isNew) {
        authId = this.target.authId
        otherId = this.target.otherId
      }

      // 権限登録
      let authData = { authId }
      for (let i = 0; i < this.auth.length; i++) {
        const a = this.auth[i]
        if (a.auth) {
          authData[a.item] = true
        } else {
          authData[a.item] = false
        }
      }

      // mst_user_other登録
      let otherData = { otherId }
      for (let otherIdx = 0; otherIdx < this.other.length; otherIdx++) {
        const o = this.other[otherIdx]
        if (o.flag) {
          otherData[o.item] = true
        } else {
          otherData[o.item] = false
        }
      }

      // 部署
      let depData = []
      for (let udIdx = 0; udIdx < this.departmentHistory.length; udIdx++) {
        const dh =  this.departmentHistory[udIdx];
        let sDay = ''
        if (dh.startDay) {
          sDay = utils.getDate(dh.startDay)
        }
        let eDay = ''
        if (udIdx == 0) {
          // あり得ない未来日をセット
          eDay = '2999-12-31'
        } else {
          eDay = utils.getDate(dh.endDay)
        }
        // 保存内容成型
        let row = {
          id: dh.id,
          departmentId: dh.departmentId,
          departmentSubId: dh.departmentSubId,
          startDay: sDay,
          endDay: eDay,
          main: true
        }
        depData.push(row)
      }

      // 兼任部署
      const dep2 = []
      for (let i = 0; i < this.department2.length; i++) {
        const d = this.department2[i]
        if (d.departmentId) {
          d.main = false
          d.startDay = '2000-01-01'
          d.endDay = '2999-12-31'
          dep2.push(d)
        }
      }

      depData = depData.concat(dep2)

      // mst_user登録
      const userR = await backend.postData('user/save', { ...this.user, before: this.target, authData, otherData, depData, patrolList:this.patrolList, insertUserId: this.$store.getters.user.id })

      logManager.recordingByRegist(this, this.isNew, 'ユーザー設定', 'ユーザー（ID：' + userR.data.data + '、 ユーザー名：' + this.user.userName + '）')

      // AKBS登録連携（新規登録時のみ確認）
      if (this.isNew) {
        const akbsResult = await dialogs.showConfirmDialog('AKBS連携', 'AKBSにも登録しますか？')
        if (akbsResult === 'YES') {
          this.openAkbsUserRegist(this.user.eMailAdress, this.user.userPassword, this.user.userName)
        }
      }

      this.$emit('modalClose')
      this.closed()
    },

    /**
     * AKBSのユーザー登録画面を別タブで開き、メールアドレス・パスワード・ユーザー名を事前入力する
     * @param email メールアドレス
     * @param password パスワード
     * @param userName ユーザー名
     */
    async openAkbsUserRegist(email, password, userName) {
      const akbsWindow = window.open(PIGEON_CONFIG.akbsUrl + 'userMaster', '_blank')
      if (!akbsWindow) {
        const retry = await dialogs.showConfirmDialog(
          'ポップアップがブロックされました',
          'ブラウザの設定でポップアップを許可してから「再送信」を押してください。',
          '再送信',
          '閉じる'
        )
        if (retry === 'YES') {
          this.openAkbsUserRegist(email, password, userName)
        }
        return
      }

      const targetOrigin = new URL(PIGEON_CONFIG.akbsUrl).origin
      let handshakeDone = false
      const handshake = (event) => {
        if (event.source !== akbsWindow || event.origin !== targetOrigin || event.data !== 'AKBS_PREFILL_READY') {
          return
        }
        handshakeDone = true
        akbsWindow.postMessage({ type: 'AKBS_PREFILL_USER', email, password, userName }, targetOrigin)
        window.removeEventListener('message', handshake)
      }
      window.addEventListener('message', handshake)

      // AKBSが一定時間内に応答しない場合（未ログインでログイン画面に遷移した等）はリスナーを破棄する
      setTimeout(() => {
        if (handshakeDone) {
          return
        }
        window.removeEventListener('message', handshake)
      }, 8000)
    },

    /**
     * 必須項目アラート
     * @param item 項目名
     */
    async errRequired(item) {
      await dialogs.showErrorDialog(item + 'は必須です', item + 'が入力されていません。')
    },

    /**
     * ツールチップ（課）
     * @param id 部署ID
     * @param sub サブリスト
     */
    tip(id, sub) {
      if (id && id != '' && !sub.length) {
        return '選択した部署に課はありません。'
      } else {
        return ''
      }
    },

    /**
     * 開始日変更イベント
     * @param sDay 開始日
     * @param i インデックス
     */
    changeStartDay(sDay, i) {
      if (sDay && sDay != '' && this.departmentHistory[i+1]) {
        this.departmentHistory[i+1].endDay = utils.addDays(sDay, -1)
      }
    },

    /**
     * 休みが決まっている曜日クリックイベント
     */
    clickHolidayWeeks(w) {
      if (!this.user.holidayWeeks) {
        this.user.holidayWeeks = []
      }
      if (this.user.holidayWeeks.includes(w.value)) {
        this.user.holidayWeeks = this.user.holidayWeeks.filter((h) => {
          return h != w.value
        })
      } else {
        this.user.holidayWeeks.push(w.value)
      }
    },

    /**
     * 上司の名前セット
     */
    setBoss() {
      if (this.user.bossId) {
        const b = this.boss.find((b) => {
          return this.user.bossId == b.id
        })
        if (b && b.name) {
          this.user.boss = b.name
        } else {
          this.user.boss = null
        }
      }
    }
  }
}
</script>
<style scoped>
.content-container-app {
  width: 988px;
  padding: 10px;
}

/* 下のボタンの帯（スクロールしても見える。上に薄い線） */
.btn-bar {
  padding-top: 8px;
  padding-bottom: 0;
  border-top: 1px solid #e5e7eb;
}

.border-gray {
  border: solid #d3cfcf 1px;
}

.td-height {
  height: 40px;
}

.input {
  height: 50px;
}

.table {
  width: auto;
  margin: auto;
}

.table-width {
  width: 350px;
}

.number {
  width: 40px;
}

.add {
    margin-left: auto;
    margin-right: 35px;
    width: 24px;
}

.department {
  display: flex;
}

.con {
  display: flex;
  justify-content: space-around;
}

.drop {
  width: 92%;
  margin-right: auto;
}

.route {
  height: 20px;
}

.add-color {
  background: darkcyan;
}

.add-color:hover {
  background: rgb(94, 196, 196);
}

.green-check {
  color: rgb(39, 152, 39);
}

.stamp-block {
  position: relative;
}

/* 画像の下に置くボタン（印鑑添付・名札作成） */
.upload-button {
  margin-top: 6px;
}

#imageStamp {
  width: 55px;
  height: 55px;
  display: block;
}

/* 名札用の顔写真（小さく。名札と同じ縦長の比。高さは印鑑の画像と同じ 55px にして、下のボタンの位置をそろえる） */
.nameplate-photo {
  width: 41px;
  height: 55px;
  display: block;
  object-fit: cover;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  background: #fff;
}

.nameplate-photo.none {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  color: #9ca3af;
  background: #f9fafb;
}

@media screen and (max-width: 910px) {
  .content-container-app {
    width: 900px !important;
  }

  .btn {
    position: static;
    width: 100%;
  }

  .form {
    margin-bottom: 30px;
  }
}
</style>